var map = {
	"./audition.svg": 1940,
	"./avi.svg": 1941,
	"./doc.svg": 1942,
	"./exe.svg": 1943,
	"./file.svg": 1185,
	"./jpg.svg": 1944,
	"./mp3.svg": 1945,
	"./mp4.svg": 1946,
	"./pdf.svg": 1947,
	"./ppt.svg": 1948,
	"./rtf.svg": 1949,
	"./txt.svg": 1950,
	"./xls.svg": 1951,
	"./zip.svg": 1952
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1939;


//////////////////
// WEBPACK FOOTER
// ./src/components/vue-beautiful-chat/src/assets/file_icons ^\.\/.*\.svg$
// module id = 1939
// module chunks = 120